var app = angular.module("leonardo");

var OnDemandSubCategoryController = function($scope, $state, categoryObj, ConfigThemeService, ngDialog, AccountUserService,
                                             Upload, OnDemandSubCategoryService, FolderFileService, AuthDataService,
                                             FormErrorsService, $timeout, AccountService, FileService, NotificationService,
                                             ClientInstanceService, AttachmentService) {

  $scope.create = $state.current.action === 'create' ;
  $scope.file = null;
  $scope.file_default = null;
  $scope.errorSize = false;
  $scope.subcategory = categoryObj;
  $scope.url_image_default = '';
  $scope.categories = [];
  $scope.authDataService = AuthDataService;
  $scope.clientInstanceService = ClientInstanceService;

  if ($scope.create) {
    $scope.subcategory.client_instance = AuthDataService.getClientInstance();
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          permission: 'permission_add_on_demand_category'
        }
      }).then(function (account) {
        if (!account){
          window.history.back();
        }
        $scope.subcategory.account = (account !== 'all') ? account : null;
      }, function() {
        window.history.back();
      });
    }
    else if (AuthDataService.isNotStaff()) {
      $scope.subcategory.account = (categoryObj && categoryObj.account) ? categoryObj.account : AccountUserService.currentAccountUser.account;
    }
    $scope.url_image_default = ConfigThemeService.getLogo('logo1');
    if ($scope.url_image_default) {
      FolderFileService.getFileObject($scope.url_image_default, function (data) {
        var array_url = $scope.url_image_default.split('/');
        var array_filename = array_url[array_url.length - 1].split('.');
        $scope.file_default = new FileService([data], array_url[array_url.length - 1], {type: 'image/' + array_filename[array_filename.length-1], lastModified: new Date()});
        $scope.$apply();
      });
    }
  }
  else if ($scope.subcategory.id) {
    if (AuthDataService.isNotStaff()) {
      $scope.subcategory.account = (categoryObj && categoryObj.account) ? categoryObj.account : AccountUserService.currentAccountUser.account;
    }
    $scope.subcategory.client_instance = ($scope.subcategory.client_instance && $scope.subcategory.client_instance.id) ? $scope.subcategory.client_instance.id : $scope.subcategory.client_instance;
    if($scope.subcategory.image) {
      FolderFileService.getFileObject($scope.subcategory.image, function (fileObject) {
        if (fileObject) {
          var array_url = $scope.subcategory.image.split('/');
          var array_filename = array_url[array_url.length - 1].split('.');
          var type = fileObject.type || 'image/' + array_filename[array_filename.length-1];
          var file = new FileService([fileObject], array_url[array_url.length-1], {type: type});
          $scope.onFileUpload(file, true);
          $scope.$apply();
        }
        else {
          $scope.subcategory.image = null;
          $scope.$apply();
        }
      });
    }
  }

  $scope.onFileUpload = function(file, hideCrop) {
    if (!file) {
      return;
    }
    var svg = file.name ? file.name.split('.svg') : [];
    if (!hideCrop && (svg.length === 1)){
      ngDialog.openConfirm({
        template: 'views/templates/dialog/attachment/image-crop.html',
        className: 'ngdialog-theme-default ngdialog-iframe',
        controller: 'ImageCrop',
        data: {
          file: file
        }
      }).then(function (file_result) {
        $scope.errorSize = AttachmentService.checkErrorSize(file_result);
        if ($scope.errorSize) {
          return;
        }
        $scope.file = file_result;
        $scope.subcategory.image = file_result;
        var formdata = new FormData();
        formdata.append('file', file_result);
        $scope.subcategory.image.file = formdata;
      }, function () {
        return;
      });
    }
    else {
      $scope.errorSize = AttachmentService.checkErrorSize(file);
      if ($scope.errorSize) {
        return;
      }
      $scope.file = $scope.subcategory.image ? angular.copy($scope.subcategory.image) : file;
      $scope.subcategory.image = file;
      var fd = new FormData();
      fd.append('file', file);
      $scope.subcategory.image.file = fd;
    }
  };

  $scope.removeFile = function() {
    $scope.errorSize = false;
    $scope.subcategory.image = null;
    $scope.file = null;
    $scope.file_default = null;
  };

  $scope.getData = function(){
    var data ={
      //white_label: AuthDataService.getWhiteLabel(),
      client_instance: AuthDataService.getClientInstance(),
      description: $scope.subcategory.description || '',
      image: $scope.subcategory.image || '',
      name: $scope.subcategory.name,
      category: $scope.subcategory.category
    };
    if ($scope.subcategory.account) {
      data.account = $scope.subcategory.account;
    }
    return data;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if (!$scope.subcategory.image) {
      $scope.onFileUpload($scope.file_default, true);
    }
    var data = $scope.getData();
    if ($scope.create) {
      Upload.upload({
        url: ConfigThemeService.generateURL('/api/2.0/on-demand-subcategories/'),
        arrayKey: '',
        data: data
      }).then(function (result) {
        $scope.submitCallback(result);
      }, function (error) {
        NotificationService.error(error);
      });
    }
    else {
      Upload.upload({
        url: ConfigThemeService.generateURL('/api/2.0/on-demand-subcategories/' + $scope.subcategory.id + '/'),
        arrayKey: '',
        data: data,
        method: 'PUT'
      }).then(function (result) {
        $scope.submitCallback(result);
      }, function (error) {
        NotificationService.error(error);
      });
    }
  };

  $scope.submitCallback = function (result) {
    OnDemandSubCategoryService.updateCollection(result.data);
    $timeout(function () {
      $state.go('on-demand-instructions');
    }, 20);
  };

  $scope.showOnDemandDeleteDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/on-demand-instructions/delete.html',
      controller: 'OnDemandDeleteDialog',
      data: {
        item: $scope.subcategory,
        type: 'subcategory'
      }
    }).then(function() {
      OnDemandSubCategoryService.updateCollection($scope.subcategory, true);
    }, function () {
      return;
    });
  };

  $scope.$on('on-demand-instruction:updated', function () {
    $state.go('on-demand-instructions.categories');
  });

};

app.controller('OnDemandSubCategoryController', ['$scope', '$state', 'categoryObj', 'ConfigThemeService', 'ngDialog',
  'AccountUserService', 'Upload', 'OnDemandSubCategoryService', 'FolderFileService', 'AuthDataService',
  'FormErrorsService', '$timeout', 'AccountService', 'FileService', 'NotificationService', 'ClientInstanceService',
  'AttachmentService', OnDemandSubCategoryController]);
